import React from 'react';
import classNames from 'classnames';
import styles from './NodeHeader.module.scss';
import Icon, { IconName } from '../Icon/Icon';

export interface NodeHeaderProps {
  title: string;
  subtitle: string;
  icon: IconName;
  onActionClick: () => void;
  backgroundColor?: string;
  isEditMode?: boolean;
  actionElement?: React.ReactNode;
}

const NodeHeader: React.FC<NodeHeaderProps> = ({
  title,
  subtitle,
  icon,
  onActionClick,
  backgroundColor,
  isEditMode,
  actionElement,
}) => {
  return (
    <div className={classNames(styles.root)}>
      <div className="flex items-center gap-x-12">
        <div className={classNames(styles.icon, backgroundColor ? `!bg-[${backgroundColor}]` : '')}>
          <Icon name={icon} width={20} height={20} className="text-white" />
        </div>
        <div className="flex flex-col">
          <span className="typo-text-14--bold text-full pb-4">{title}</span>
          <span className="typo-text-12 text-faded">{subtitle}</span>
        </div>
        {isEditMode && (
          <div className="flex ml-auto">
            {actionElement || (
              <button type="button" aria-label="Delete" onClick={onActionClick}>
                <Icon name="deleteWidget" width={20} height={20} className="text-faded" />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default NodeHeader;
